export default __webpack_public_path__ + "0fe02c386b4653eb39314d27e82d6ad9.png";